import { Component, OnDestroy, OnInit } from "@angular/core";
import { LimitePagamentoEcgTerceiroService } from "../limite-pagamento-ecg-terceiro.service";
import { TipoPagamentoEcgTerceiro } from "src/app/model/tipo-pagamento-ecg-terceiro";
import { TipoPagamentoEcgTerceiroService } from "../../contratacao/operacao/tipo-pagamento-ecg-terceiro.service";
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HistoricoLimiteFundoCadastro } from "src/app/model/limite-agente-financeiro.model";
import Utils from "src/app/shared/fgi-utils";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-limite-pagamento-ecg-por-terceiros-historico",
  templateUrl: "./limite-pagamento-ecg-por-terceiros-historico.component.html",
  styleUrls: ["./limite-pagamento-ecg-por-terceiros-historico.component.scss"],
  standalone: false
})
export class LimitePagamentoEcgPorTerceirosHistoricoComponent
  implements OnInit, OnDestroy
{
  private readonly destroy$: Subject<any> = new Subject<any>();
  tipos: TipoPagamentoEcgTerceiro[] = [];
  tipoPagamentoEcgTerceiroControl: FormControl;
  historicos: HistoricoLimiteFundoCadastro[] = [];
  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public atributosPaginacao: EntityPagedResult<HistoricoLimiteFundoCadastro>;
  private totalObjetosRetornados: number;
  pesquisado: boolean = false;

  constructor(
    private limiteService: LimitePagamentoEcgTerceiroService,
    private tipoPagamentoEcgTerceiroService: TipoPagamentoEcgTerceiroService,
    private loadingService: BnLoadingService
  ) {
    this.tipoPagamentoEcgTerceiroControl = new FormControl(
      null,
      Validators.required
    );
    this.opcoesPaginacao = [5, 10, 15, 20];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined,
    };
    this.tipoPagamentoEcgTerceiroControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((ideTipo: any) => {
        if (Number(ideTipo) > 0) {
          this.buscar(false, true);
        } else {
          this.atributosPaginacao.page = 1;
          this.historicos = [];
        }
      });
  }

  ngOnInit() {
    this.carregarTipos();
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }


  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.historicos = this.historicos.sort((a, b) => {
      if (ord.sentido == 'asc') {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      } else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(false);
    this.destroy$.complete();
  }

  async carregarTipos() {
    this.tipos = await this.tipoPagamentoEcgTerceiroService
      .listarTodos()
      .toPromise();
  }

  async buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    const ideTipo = this.tipoPagamentoEcgTerceiroControl.value;
    if (!ideTipo) {
      return;
    }

    this.pesquisado = false;
    if (voltarPagina1) {
      this.atributosPaginacao.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(
      this.historicos,
      this.atributosPaginacao,
      this.totalObjetosRetornados
    );
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacao.page = this.atributosPaginacao.pages;
    }

    const params: any = {};
    params.pagina = this.atributosPaginacao.page;
    params.limite = this.atributosPaginacao.pageSize;

    const response = await this.limiteService.buscarHistoricoPorIdeTipo(
      ideTipo,
      params
    );
    this.historicos = response ? response.resultados : undefined;
    this.atributosPaginacao.count = response
      ? response.totalRegistrosSemPaginacao
      : 0;
    this.totalObjetosRetornados = this.atributosPaginacao.count;
    this.pesquisado = true;
    this.loadingService.liberaTela();

    paginaVazia = Utils.verificaPaginaVazia(
      this.historicos,
      this.atributosPaginacao,
      this.totalObjetosRetornados
    );
    if (paginaVazia && !voltarPagina1) {
      this.buscar(false, true);
    }
  }

  mudancaPagina(novaPagina: EntityPagedResult<HistoricoLimiteFundoCadastro>) {
    this.atributosPaginacao = novaPagina;
    this.buscar(false, false);
  }

}
